<template>
    <div class="nevs-content">
        <div class="nevs-content-top-buttons">
            <NevsButton class="primary" @click="addClick">
                <i class="fa-solid fa-plus"></i>
                {{ $LANG.Get('buttons.add') }}
            </NevsButton>
            <NevsButton class="primary" @click="excelClick">
                <i class="fa-solid fa-file-excel"></i>
                {{ $LANG.Get('buttons.excel') }}
            </NevsButton>
        </div>
        <NevsCard>
            <NevsTable
                :default-sort="tableData.defaultSort"
                :fields="tableData.fields"
                :height="tableData.height"
                :total-records="tableData.totalRecords"
                @reload="reloadTable">
                <tr class="nevs-table-filters">
                    <td>
                        <NevsTextField v-model="tableData.filters.first_name"></NevsTextField>
                    </td>
                    <td>
                        <NevsTextField v-model="tableData.filters.last_name"></NevsTextField>
                    </td>
                    <td>
                        <NevsTextField v-model="tableData.filters.member_id"></NevsTextField>
                    </td>
                    <td>
                        <NevsTextField v-model="tableData.filters.company"></NevsTextField>
                    </td>
                    <td>
                        <NevsTextField v-model="tableData.filters.membership"></NevsTextField>
                    </td>
                    <td>
                        <NevsSelect v-model="tableData.filters.active_membership"
                                    :options="$HELPERS.GetYesNoAllOptions(this)"></NevsSelect>
                    </td>
                    <td></td>
                </tr>
                <tr v-for="(item, key) in tableData.records" :key="key">
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.first_name }}</td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.last_name }}</td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.member_id }}</td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.company_name }}</td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">
                        <template v-if="item.membership_name">
                            <span v-for="(name, mkey) in item.membership_name.split('\n')" :key="mkey"
                                  class="membership-pill membership-pill-active">{{ name }}</span>
                        </template>
                        <span v-else class="membership-pill membership-pill-none">{{ $LANG.Get('labels.noMembership') }}</span>
                    </td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.active_membership_display }}</td>
                    <td class="nevs-table-actions">
                        <span v-if="item.note" class="persons-note-icon" :title="item.note" @click="showNote(item.note)"><i class="fa-solid fa-note-sticky"></i></span>
                        <span :title="$LANG.Get('tooltips.openInNewWindow')" class="nevs-table-button"
                            @click="openClick(item.id, true)"><i class="fa-solid fa-up-right-from-square"></i></span>
                    </td>
                </tr>
            </NevsTable>
        </NevsCard>
        <NevsCheckbox class="persons-show-deactivated" :width="'auto'"
                      v-model="tableData.filters.show_deactivated"
                      :label="$LANG.Get('labels.showDeactivatedPersons')"></NevsCheckbox>
    </div>
</template>

<script>
import NevsCard from "@/components/nevs/NevsCard.vue";
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsTable from "@/components/nevs/NevsTable.vue";
import NevsTextField from "@/components/nevs/NevsTextField.vue";
import NevsSelect from "@/components/nevs/NevsSelect.vue";
import NevsCheckbox from "@/components/nevs/NevsCheckbox.vue";

export default {
    name: "ModulePersons",
    components: {NevsCheckbox, NevsSelect, NevsTextField, NevsTable, NevsButton, NevsCard},
    data() {
        return {
            tableData: {
                fields: [
                    {
                        name: 'first_name',
                        label: this.$LANG.Get('fields.firstName')
                    },
                    {
                        name: 'last_name',
                        label: this.$LANG.Get('fields.lastName')
                    },
                    {
                        name: 'member_id',
                        label: this.$LANG.Get('fields.memberId')
                    },
                    {
                        name: 'company_name',
                        label: this.$LANG.Get('fields.company')
                    },
                    {
                        name: 'membership_name',
                        label: this.$LANG.Get('fields.membership')
                    },
                    {
                        name: 'active_membership',
                        width: '140px',
                        label: this.$LANG.Get('labels.activeMembership')
                    },
                    {
                        name: 'actions',
                        width: '50px',
                        label: ''
                    }
                ],
                filters: {
                    first_name: '',
                    last_name: '',
                    member_id: '',
                    company: '',
                    membership: '',
                    active_membership: -1,
                    show_deactivated: false
                },
                records: [],
                lastRequest: null,
                totalRecords: 0,
                defaultSort: {
                    field: 'first_name',
                    descending: false
                },
                filterTimer: null,
                height: '0px'
            },
            crossTabHandle: null
        }
    },
    watch: {
        'tableData.filters': {
            handler() {
                if (this.filterTimer !== null) {
                    clearTimeout(this.filterTimer);
                }
                let vm = this;
                this.filterTimer = setTimeout(function () {
                    vm.reloadTable(vm.tableData.lastRequest);
                    vm.filterTimerOn = false;
                }, 500);
            },
            deep: true
        }
    },
    methods: {
        showNote(note) {
            this.$LOCAL_BUS.TriggerEvent('popup', {
                type: 'alert',
                text: note.split('\n').join('<br>')
            });
        },
        openClick(id, newWindow = false) {
            if (newWindow) {
                let routeData = this.$router.resolve('/persons/' + id);
                window.open(routeData.href);
            } else {
                this.$router.push('/persons/' + id);
            }
        },
        addClick() {
            this.$router.push('/persons/0');
        },
        excelClick() {
            let excelRequest = JSON.parse(JSON.stringify(this.tableData.lastRequest));
            excelRequest.rowsPerPage = 0;

            let vm = this;
            vm.$API.APICall('get', 'persons/excel', excelRequest, (data, success) => {
                if (success) {
                    window.open(data.link);
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        },
        reloadTable(request) {
            let vm = this;
            request.filters = this.tableData.filters;
            this.tableData.lastRequest = JSON.parse(JSON.stringify(request));
            this.$API.APICall('get', 'persons', request, (data, success) => {
                if (success) {
                    vm.tableData.records = data.records;
                    vm.tableData.totalRecords = data.total_records;
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        },
        resolveWindowResize() {
            this.tableData.height = window.innerHeight - 245 + 'px';
        }
    },
    mounted() {

        this.$store.commit('selectMenu', 'clients');
        this.$store.commit('selectSubMenu', 'persons');
        this.$store.commit('setBreadcrumbs', [
            {
                label: this.$LANG.Get('modules.clients'),
                link: null
            },
            {
                label: this.$LANG.Get('modules.persons'),
                link: null
            }
        ]);
        window.addEventListener('resize', this.resolveWindowResize);
        this.resolveWindowResize();
        let vm = this;
        this.crossTabHandle = this.$CROSS_TAB_BUS.ListenToEvent('reload-persons', () => {
            vm.reloadTable(vm.tableData.lastRequest);
        });
    },
    unmounted() {
        if (this.crossTabHandle !== null) {
            this.$CROSS_TAB_BUS.UnbindEvent(this.crossTabHandle);
        }
    }
}
</script>

<style scoped lang="scss">
@use '../../scss/vars' as *;

.membership-pill {
    display: inline-block;
    text-align: center;
    padding: 5px 10px;
    border-radius: 5px;
    margin: 2px;
}

.membership-pill-active {
    background: $success-badge;
}

.membership-pill-none {
    background: $danger-bright;
    color: $white;
}

.persons-show-deactivated {
    margin-top: 10px;
}

.persons-note-icon {
    color: $warning;
    margin-right: 12px;
    cursor: pointer;
}
</style>